export default __webpack_public_path__ + "static/media/gas.6c272864.png";